module.exports = __webpack_public_path__ + "static/media/MasterBed1-1.dcd53a1a.jpg";